import { useTenant } from "../../contexts/TenantContext";
import { getCompanyTenant } from "../../constants/companies";

const TenantRoute = ({ default: DefaultComponent, ...tenantComponents }) => {
  const { tenantId } = useTenant();

  if (!tenantId) {
    return DefaultComponent;
  }

  // Convert tenant GUID to tenant key (e.g., "bee", "adentis")
  const tenantKey = getCompanyTenant(tenantId);

  if (tenantComponents[tenantKey]) {
    return tenantComponents[tenantKey];
  }

  return DefaultComponent;
};

export default TenantRoute;
